<template>
  <vx-card class="mt-5">
    <div id="import-customer-data">
      <vs-tabs>
        <vs-tab label="Bulk Import">
          <div class="flex flex-wrap items-center">
            <vs-alert active="true" class="mt-5">
              Bulk import your customers into Smart Invoice Platform.
            </vs-alert>
            <vx-card
              v-if="validationErrors === null"
              id="import-form"
              class="mt-5"
            >
              <div class="flex flex-wrap-reverse justify-end flex-grow">
                <div class="flex flex-wrap-reverse">
                  <vs-button
                    @click="onReloadPage"
                    color="primary"
                    type="border"
                    size="small"
                    class="ml-3"
                    >Clear File</vs-button
                  >
                </div>
              </div>
              <h4 class="mb-4">Upload File</h4>
              <!--<vue-csv-import
                v-model="csv"
                :map-fields="defaultFields"
                :auto-match-fields="autoMatchFields"
                :headers="autoMatchFields"
                input-class="vs-inputx vs-input--input normal"
                button-class="mt-3 mb-3 vs-component vs-button vs-button-primary vs-button-border small"
                table-select-class="vs-inputx vs-input--input normal"
                checkbox-class="mb-3 form-check-input"
                table-class="import-table"
                load-btn-text="Load CSV"
              >
                <vue-csv-input name="csvFile" ref="csv1"></vue-csv-input>
                <template slot="thead">
                  <tr>
                    <th width="25%" class="mb-4 import-table-header">
                      <h5>Fields</h5>
                    </th>
                    <th width="75%" class="mb-4 import-table-header">
                      <h5>CSV Column</h5>
                    </th>
                  </tr>
                </template>
              </vue-csv-import>-->
              <input type="file"  @change="handleFileUpload( $event )" class="rounded-lg vs-inputx vs-input--input normal"/>
            </vx-card>
            <vx-card
              v-if="validationErrors !== null"
              id="validation-erros"
              class="mt-5"
            >
              <h4 class="mb-4">Import Errors</h4>
              <vs-table stripe ref="table" :data="validationErrors">
                <template slot="thead">
                  <vs-th>Item(s)</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td>{{ tr }}</vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </vx-card>
            <vx-card v-else-if="csv !== null" id="import-preview" class="mt-5">
              <h4 class="mb-4">Preview Data</h4>
              <div
                class="flex flex-wrap-reverse justify-end flex-grow mt-6 mb-6"
              >
                <div class="flex flex-wrap-reverse data-list-btn-container">
                  <vs-button
                    class="ml-3"
                    :disable="isSubmitButtonEnabled"
                    @click="submitData"
                  >
                    <div v-if="isProcessing === false">Upload</div>
                    <div v-if="isProcessing">Processing...</div>
                  </vs-button>
                </div>
              </div>
              <vs-table stripe ref="table" :data="customers">
                <template slot="thead">
                  <vs-th sort-key="id">ID</vs-th>
                  <vs-th sort-key="name">Name</vs-th>
                  <vs-th sort-key="email">Email</vs-th>
                  <vs-th sort-key="type">Type</vs-th>
                  <vs-th sort-key="payment_term_types">Payment Term</vs-th>
                  <vs-th sort-key="address1">Address 1</vs-th>
                  <vs-th sort-key="address2">Address 2</vs-th>
                  <vs-th sort-key="city">City</vs-th>
                  <vs-th sort-key="state">State</vs-th>
                  <vs-th sort-key="postal_code">Postal Code</vs-th>
                  <vs-th sort-key="country">Country</vs-th>
                  <vs-th sort-key="phone">Phone</vs-th>
                  <vs-th sort-key="reference1">Reference 1</vs-th>
                  <vs-th sort-key="reference2">Reference 2</vs-th>
                  <vs-th sort-key="reference3">Reference 3</vs-th>
                  <vs-th sort-key="notes">Notes</vs-th>
                  <vs-th sort-key="parentCustomerId">Parent Customer ID</vs-th>
                  <vs-th sort-key="accountManagerEmailAddress"
                    >Account Manager Email</vs-th
                  >
                </template>
                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td>{{ tr.customerId }}</vs-td>
                      <vs-td>{{ tr.name }}</vs-td>
                      <vs-td>
                        <span
                          v-for="item in tr.contactEmailAddresses"
                          v-bind:key="item.emailAddress"
                        >
                          {{ item.emailAddress }}<br />
                        </span>
                      </vs-td>
                      <vs-td>{{ tr.type }}</vs-td>
                      <vs-td
                        >{{ tr.paymentTermType }}<br />{{
                          tr.netPaymentTermDay
                        }}</vs-td
                      >
                      <vs-td>{{ tr.address1 }}</vs-td>
                      <vs-td>{{ tr.address2 }}</vs-td>
                      <vs-td>{{ tr.city }}</vs-td>
                      <vs-td>{{ tr.state }}</vs-td>
                      <vs-td>{{ tr.postalCode }}</vs-td>
                      <vs-td>{{ tr.country }}</vs-td>
                      <vs-td>{{ tr.phone }}</vs-td>
                      <vs-td>{{ tr.reference1 }}</vs-td>
                      <vs-td>{{ tr.reference2 }}</vs-td>
                      <vs-td>{{ tr.reference3 }}</vs-td>
                      <vs-td>{{ tr.notes }}</vs-td>
                      <vs-td>{{ tr.parentCustomerId }}</vs-td>
                      <vs-td>{{ tr.accountManagerEmailAddress }}</vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </vx-card>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </vx-card>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import GenericUpload from '@/views/components/override/GenericUpload.vue'
import vSelect from 'vue-select'
import customerImportCsvParser from '@/mixins/customer-import'
import Papa from 'papaparse'
import axios from '@/axios'

export default {
  props: {},
  components: {
    VuePerfectScrollbar,
    GenericUpload,
    vSelect,
  },
  data() {
    return {
      csv: null,
      customers: [],
      isProcessing: false,
      defaultFields: [
        'customerid',
        'name',
        'emailAddress',
        'type',
        'paymentTermType',
        'netPaymentTermDay',
        'address1',
        'address2',
        'city',
        'state',
        'postalCode',
        'country',
        'phone',
        'reference1',
        'reference2',
        'reference3',
        'notes',
        'parentCustomerId',
        'accountManagerEmailAddress',
      ],
      autoMatchFields: true,
      validationErrors: null,
      activeTenant: this.$store.state.AppActiveUser.activeTenant,
      fileinput:'',
    }
  },
  computed: {
    isSubmitButtonEnabled() {
      return this.csv !== null || this.isProcessing === true
    },
  },
  watch: {
    csv: function(val) {
      if (!val) return
    },
  },
  /*    this.customers = customerImportCsvParser.methods.parseCsv(val)
      if (this.customers.length > 0) {
        this.validationErrors = null
      }
    },
  },*/
  methods: {
    validateData(val) {
      this.customers = customerImportCsvParser.methods.parseCsv(
        val
      )

      if (this.customers.length > 0) {
        this.validationErrors = null
      }
    },
    handleFileUpload(event) {
      this.csv = event.target.files[0];
      this.parseFile();
    },
    //method to parse the csv file
    parseFile(){
      Papa.parse( this.csv, {
          header: true,
          skipEmptyLines: true,
          complete: function( results ){
            console.log('results' + JSON.stringify(results));
              this.fileinput = results.data;
              this.validateData(this.fileinput);
          }.bind(this)
      } );
    },
    
    // TODO: look for method / alternative to clear vue-csv-import file cache instead reload page
    async onReloadPage() {
      location.reload()
    },
    async submitData() {
      let successMessage = 'Added Successful'
      let successText = 'Record has successfully Added'
      let failMessage = 'Added Failed'
      let failText = 'Failed to add record'
      this.isProcessing = true
      let fileId = ''

      //s3upload
      const inputElement = document.querySelector("input[type='file']")
      const fileUpload = document.getElementsByTagName('input')

      const filename = inputElement.value.split(/(\\|\/)/g).pop()
      const payload = { attachmentType: 'upload', name: filename }
      const filePayload = {
        tenantId: this.activeTenant,
        id: '',
        fileUrl: '',
        fileKey: '',
        fileType: 'Customer',
        fileName: payload.name,
      }
      if (fileUpload) {
        this.$store
          .dispatch('files/getSignedUrl', payload)
          .then(async result => {
            const signedUrl = result.data.url
            filePayload.fileKey = result.data.key
            await axios
              .put(signedUrl, inputElement.files[0], {
                headers: {
                  'Content-Type': 'text/csv',
                },
              })
              .then(async response => {
                filePayload.fileUrl = response.config.url
                await this.$store
                  .dispatch('files/addFile', filePayload)
                  .then(fileRes => {
                    filePayload.id = fileRes.data.id
                    fileId = filePayload.id
                  })
                  .catch(error => {})
              })
              .catch(error => {})
          })
          .catch(err => {
            let message = failText
            if (err.response.data.error) {
              message = err.response.data.error
            }
            this.$vs.notify({
              color: 'danger',
              title: failMessage,
              text: message,
            })
          })
          .finally(() => {
            this.isProcessing = false
            return new Promise(async (resolve, reject) => {
              await axios
                .post('/tenant-customers/import-tenant-customers', filePayload)
                .then(async resp => {
                  // console.log('resp ' + JSON.stringify(resp));
                })
                .catch(err => {
                  // console.log('err ' + JSON.stringify(err));
                })
                .finally(async () => {})
              this.$router.push('/files').catch(() => {})
            })
          })
      }
    },
  },
}
</script>

<style lang="scss">
.import-table-header {
  padding: 3px 0px;
}

.import-table {
  width: -webkit-fill-available;

  table > thead > tr > th {
    padding: 0px 0px;
  }
}
</style>
